import { Component, ErrorInfo, ReactNode } from 'react';

// 1. Define the props type (must allow children).
interface ErrorBoundaryProps {
  children?: ReactNode;
}

// 2. Define the state type for tracking errors.
interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  // 3. Update state so the next render shows a fallback UI.
  static getDerivedStateFromError(error: Error): Partial<ErrorBoundaryState> {
    return { hasError: true, error };
  }

  // 4. Log details about the error.
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Error boundary caught an error:', error, errorInfo);
    // Optionally send this info to an external logging service
  }

  render() {
    const { hasError, error } = this.state;
    if (hasError) {
      return (
        <div style={{ padding: '2rem' }}>
          <h1>Something went wrong.</h1>
          {error && <p>Error details: {error.message}</p>}
        </div>
      );
    }
    // If no error, render children normally
    return this.props.children;
  }
}
